import ReduxCheckbox, {
  CheckboxField,
  SquareField,
  SquareReduxField,
} from './Checkbox'
import ReduxColorInput, {
  ColorInput as ClassicColorInput,
} from './ColorPalette'
import ReduxDateInput, { DateInput as ClassicDateInput } from './DateInput'
import ConnectedDateRangeInput, {
  DateRangeInput as ClassicDateRangeInput,
} from './DateRangeInput'
import Form from './Form'
import ClassicFormGroup, { FlexGroup } from './FormGroup'
import ReduxNumberInput, {
  NumberInput as ClassicNumberInput,
} from './NumberInput'
import ReduxPasswordInput, {
  PasswordInput as ClassicPasswordInput,
} from './PasswordInput'
import CountrySelect from './CountrySelect'
import ReduxRadio, { CustomRadio, CustomReduxRadio, RadioField } from './Radio'
import ReduxSelect, {
  CreatableSelectInput,
  CreatableSelectInputRedux,
  Option,
  SelectInput as ClassicSelect,
} from './Select'
import ReduxTagInput, { TagInput as ClassicTagInput } from './TagInput'
import ReduxTextareaInput, {
  TextareaInput as ClassicTextareaInput,
} from './TextareaInput'
import ReduxTextInput, { TextInput as ClassicTextInput } from './TextInput'
import ReduxTimeInput, { TimeInput as ClassicTimeInput } from './TimePicker'
import ReduxPriceInput, {
  PriceInput as ClassicPriceInput,
} from './PriceInput/PriceInput'
import { MainPrice, MainPriceRedux } from './Custom'

const Checkbox = {
  Field: CheckboxField,
  ReduxField: ReduxCheckbox,
}

const SquareCheckbox = {
  Field: SquareField,
  ReduxField: SquareReduxField,
}

const NumberInput = {
  Field: ClassicNumberInput,
  ReduxField: ReduxNumberInput,
}

const PriceInput = {
  Field: ClassicPriceInput,
  ReduxField: ReduxPriceInput,
}

const TextInput = {
  Field: ClassicTextInput,
  ReduxField: ReduxTextInput,
}

const TextareaInput = {
  Field: ClassicTextareaInput,
  ReduxField: ReduxTextareaInput,
}

const Radio = {
  Custom: CustomRadio,
  CustomRedux: CustomReduxRadio,
  Field: RadioField,
  ReduxField: ReduxRadio,
}

const Select = {
  Field: ClassicSelect,
  Option,
  ReduxField: ReduxSelect,
}

const CreatableSelect = {
  Field: CreatableSelectInput,
  Option,
  ReduxField: CreatableSelectInputRedux,
}

const ColorInput = {
  Field: ClassicColorInput,
  ReduxField: ReduxColorInput,
}

const TagInput = {
  Field: ClassicTagInput,
  ReduxField: ReduxTagInput,
}

const DateInput = {
  Field: ClassicDateInput,
  ReduxField: ReduxDateInput,
}

const DateRangeInput = {
  Field: ClassicDateRangeInput,
  ReduxField: ConnectedDateRangeInput,
}

const TimeInput = {
  Field: ClassicTimeInput,
  ReduxField: ReduxTimeInput,
}

const PasswordInput = {
  Field: ClassicPasswordInput,
  ReduxField: ReduxPasswordInput,
}

const MainPriceInput = {
  Field: MainPrice,
  ReduxField: MainPriceRedux,
}

const FormGroup = {
  Nested: FlexGroup,
  Render: ClassicFormGroup,
}

export {
  Checkbox,
  Form,
  FormGroup,
  NumberInput,
  Radio,
  Select,
  TextareaInput,
  TextInput,
  ColorInput,
  TagInput,
  DateInput,
  TimeInput,
  PasswordInput,
  SquareCheckbox,
  CreatableSelect,
  PriceInput,
  MainPriceInput,
  CountrySelect,
  DateRangeInput,
}
